/* core-sticky-atc: vezi snippets/core-sticky-atc.liquid */
(() => {
  const bar = document.querySelector('.core-sticky-atc');
  const id = bar && bar.dataset.section;
  const main = id && document.getElementById(`ProductSubmitButton-${id}`);
  if (!main || !('IntersectionObserver' in window)) return;

  const root = document.documentElement;
  const button = bar.querySelector('.core-sticky-atc__button');
  const price = bar.querySelector('.core-sticky-atc__price');
  const choose = bar.dataset.mode === 'choose';
  const banners = '#shopify-pc__banner, .cky-consent-container, #CybotCookiebotDialog, #onetrust-banner-sdk';
  let past = false;
  let footer = false;

  const visible = (el) => el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden';

  const tiers = document.getElementById(`QuantityBreaks-${id}`);

  const sync = () => {
    const box = document.getElementById(`price-${id}`);
    const sale = box && box.querySelector('.price--on-sale');
    const tier = tiers && tiers.querySelector('input:checked');
    const current =
      (tier && tier.closest('label').querySelector('.core-qb__price')) ||
      (box && box.querySelector(sale ? '.price-item--sale' : '.price__regular .price-item--regular:not(s)'));
    if (current) price.textContent = current.textContent.trim();
    if (!choose) {
      const label = main.querySelector('span');
      if (label && label.textContent.trim()) button.textContent = label.textContent.trim();
      button.disabled = main.disabled;
    }
  };

  const update = () => {
    const on =
      past &&
      !footer &&
      !/overflow-hidden/.test(document.body.className) &&
      ![...document.querySelectorAll(banners)].some(visible);
    if (on) sync();
    bar.classList.toggle('is-visible', on);
    root.classList.toggle('core-sticky-atc-on', on);
    root.style.setProperty('--core-sticky-atc-h', on ? `${bar.offsetHeight}px` : '0px');
  };

  new IntersectionObserver(
    (entries) => {
      past = !entries[entries.length - 1].isIntersecting;
      update();
    },
    { rootMargin: '0px 0px 100000px 0px' }
  ).observe(main);

  const foot = document.querySelector('.shopify-section-group-footer-group, footer');
  if (foot) {
    new IntersectionObserver((entries) => {
      footer = entries[entries.length - 1].isIntersecting;
      update();
    }).observe(foot);
  }

  new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  if (tiers) tiers.addEventListener('change', sync);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (data && data.sectionId === id) setTimeout(sync);
    });
  }

  button.addEventListener('click', () => {
    if (!choose) {
      main.click();
      return;
    }
    const panel =
      tiers ||
      document.querySelector(`#MainProduct-${id} variant-selects`) ||
      document.getElementById(`Quantity-Form-${id}`) ||
      main;
    const target = panel.querySelector('input:checked') || panel.querySelector('input:not([type="hidden"]), select') || main;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    panel.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
    target.focus({ preventScroll: true });
  });
})();
